import { payType, ServiceSubCategory, serviceType } from '@/commonTypes';
import { Breadcrumb } from '@/components/general/BreadCrumb';
import SectionHead from '@/components/general/SectionHead';
import React from 'react';
import styles from '../styles.module.css';
import PlateInput from '@/components/pages/home/HomeContent/HomeHero/PlateLookup/PlateInput';
import { useLayoutContext } from '@/context/LayoutContext';
import PlateBadge from '@/components/pages/home/HomeContent/CarSwitcher/PlateBadge';
import MainIcons from '@/icons/main';
import { PlateLookup } from '@/components/pages/home/HomeContent/HomeHero/PlateLookup';
import Button from '@/components/common/Button';
import PlatesSection from './PlateSection';

export default function SingleServiceHero({
  data,
  onClick,
  callBackHistory,
}: {
  data?: ServiceSubCategory;
  onClick?: (x?: payType, item?: any, callBackHistory?: any) => void;
  callBackHistory?: any;
}) {
  const { activeCar } = useLayoutContext();
  console.log('datas=========', data);
  const items = [
    {
      icon: <MainIcons.shieldIcon fill="var(--green-bright)" width={'14px'} height={'14px'} />,
      text: 'مرجع رسمی راهور',
    },
    {
      icon: <MainIcons.LockIcon fill="var(--green-bright)" width={'14px'} height={'14px'} />,
      text: 'پرداخت امن',
    },
    {
      icon: <MainIcons.clockIcon fill="var(--green-bright)" width={'14px'} height={'14px'} />,
      text: 'نتیجه در ۱ ثانیه',
    },
  ];
  return (
    <div className={`${styles.heroWrapper}`}>
      <Breadcrumb
        items={[
          { label: 'خانه', to: '/' },
          { label: 'سرویس‌ها', to: '/allServices' },
          { label: `${data?.title}` },
        ]}
      />
      <SectionHead
        title={'وضعیت' + ' ' + data?.title?.replace(/استعلام/g, '')?.replace(/وضعیت/g, '')}
        text={data?.description}
        type="accountHero"
        tagHref="h1"
        titleClass={`${styles.titleClass}`}
        textTitle={`${styles.textTitle}`}
      />

      <PlatesSection data={data} onClick={onClick} callBackHistory={callBackHistory} />
    </div>
  );
}
